import { abilitiesPlugin } from "@casl/vue"
import { ability } from "@/store/ability.js"

// Vue 3: Export plugin installer function
// Usage in main.js: app.use(abilitiesPlugin, ability)
export { abilitiesPlugin, ability }

// For backward compatibility, also export default installer
export default {
  install(app) {
    // Register CASL abilities plugin
    app.use(abilitiesPlugin, ability, {
      useGlobalProperties: true,
    })

    // Vue 3: Manually add $can and $ability to globalProperties for Options API compatibility
    // In @casl/vue v2+, these are not automatically added like in v1
    app.config.globalProperties.$ability = ability
    app.config.globalProperties.$can = function (action, subject) {
      return ability.can(action, subject)
    }
    app.config.globalProperties.$cannot = function (action, subject) {
      return ability.cannot(action, subject)
    }
  },
}
